import type { SuccessfullQueryResponse } from "@whatslly/types/QueryResponse";
import type { EmittedMessage, SerializedMessage } from "@whatslly/types/instant-messaging/messagesEmitter";
import type { Translations } from "@whatslly/instant-messaging/i18nService";
import type { MessageCheckboxStore, EntireDayCheckboxStore } from "../react-app/messageCheckbox/messageCheckbox";
import type { IMSelectorsUnion } from "@whatslly/types/integrations/im/IMSelectorsTypes";
export const STATUSBAR_NAMESPACE = "chat-statusbar";
export const TEMPLATES_NAMESPACE = "chat-templates";

export const FRAUD_DOM_CLASSNAMES = {
  FRAUD_MESSAGE: "whatslly-fraudMessage",
  FRAUD_MESSAGE_SHOW: "whatslly-fraudMessage-show",
  FRAUD_MESSAGE_MALICIOUS_FILE: "whatslly-fraudMessage-maliciousFile",
} as const;

export type SelectiveSyncStore = MessageCheckboxStore & { message: EmittedMessage; commit: () => Promise<void> };
export type SelectiveEntireDaySyncStore = EntireDayCheckboxStore & { messages: SelectiveSyncStore[]; mounted: boolean };

export interface IDOMInjectorService {
  injectStatusBarWidgetAndTemplates(queryResponse: SuccessfullQueryResponse, selectors: IMSelectorsUnion | undefined): void;
  startListenToThemeModeChanged(): void;
  markAsInvalidMessage(
    message: SerializedMessage,
    maxFileSizeBytes: number,
    i18n: Translations | undefined,
    selectors: IMSelectorsUnion | undefined
  ): SerializedMessage | undefined;
  markAsSynced(messageId: string, selectors: IMSelectorsUnion | undefined): string | undefined;
  hideFraudMessage(messageId: string, selectors: IMSelectorsUnion | undefined, options?: { isMaliciousFile?: boolean }): string | undefined;
  revealFraudMessage(messageId: string, selectors: IMSelectorsUnion | undefined): string | undefined;
  clearFraudMessageStyles(): void;
  cleanupMessagesDOMInstrumentations(cleanup: { selected: boolean; synced: boolean }, selectors: IMSelectorsUnion | undefined): void;
  mountSelectDayCheckbox(store: SelectiveEntireDaySyncStore, selectors: IMSelectorsUnion | undefined): SelectiveEntireDaySyncStore | undefined;
  addSelectMessageChcekbox(
    store: SelectiveSyncStore,
    selectors: IMSelectorsUnion | undefined
  ): { pending: boolean; store: SelectiveSyncStore } | undefined;
  toggleMessageSelection(
    store: SelectiveSyncStore,
    value: boolean,
    selectedMessages: Set<SelectiveSyncStore> | undefined,
    selectors: IMSelectorsUnion | undefined
  ): void;
}

export const IDOMInjectorServiceSymbol = Symbol.for("IDOMInjectorService");
